<template>
  <div>
    <h1>Account Settings</h1>
    <div v-if="user">
      <img :src="user.photoURL || defaultProfilePic" alt="Profile Picture" class="profile-pic"/>
      <input type="file" @change="uploadPhoto" accept="image/*">
      <p><strong>Email:</strong> {{ user.email }}</p>
      <button @click="changePassword">Change Password</button>
      <button @click="deleteAccount" class="danger">Delete Account</button>
      <button @click="logout">Logout</button>
    </div>
    <div v-else>
      <p>You are not logged in. Please log in to view account settings.</p>
    </div>
  </div>
</template>

<script>
import { getAuth, sendPasswordResetEmail, deleteUser, signOut, updateProfile } from 'firebase/auth';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export default {
  data() {
    return {
      user: null,
      defaultProfilePic: 'path/to/default/profile_pic.jpg' // Provide a default profile picture path
    };
  },
  mounted() {
    this.user = getAuth().currentUser;
  },
  methods: {
    async uploadPhoto(event) {
      const file = event.target.files[0];
      if (!file) return;
      const auth = getAuth();
      const user = auth.currentUser;
      const storage = getStorage();
      const storageRef = ref(storage, `profileImages/${user.uid}`);
      try {
        await uploadBytes(storageRef, file);
        const photoURL = await getDownloadURL(storageRef);
        await updateProfile(user, { photoURL });
        this.user.photoURL = photoURL; // Update local user data
        alert('Profile photo updated successfully!');
      } catch (error) {
        console.error('Error uploading file:', error);
        alert('Failed to upload profile photo.');
      }
    },
    changePassword() {
      if (this.user && this.user.email) {
        sendPasswordResetEmail(getAuth(), this.user.email)
            .then(() => alert('Password reset email sent.'))
            .catch((error) => console.error('Error sending password reset email:', error));
      }
    },
    deleteAccount() {
      if (confirm('Are you sure you want to delete your account? This cannot be undone.')) {
        if (this.user) {
          deleteUser(this.user)
              .then(() => alert('Account successfully deleted.'))
              .catch((error) => console.error('Error deleting account:', error));
        }
      }
    },
    logout() {
      const auth = getAuth();
      signOut(auth)
          .then(() => {
            this.user = null;
            alert('Logout successful.');
          })
          .catch((error) => console.error('Error logging out:', error));
    }
  }
};
</script>

<style scoped>
.profile-pic {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-bottom: 10px;
}
.danger {
  color: red;
}
</style>


